import { FullSellerRatesConfigResponse, FullSellerRatesHistoryResponse, SellerRates, SellerRatesHitoryPaginator, SellerRatesPatchResponse } from "../models/Rates"
import { api } from "../services/Api"
import { filterAndPageableToRequest } from "../utils";

export function useRates () {

  function patchSellerRates ( id: string, data: SellerRates ): Promise<SellerRatesPatchResponse> {
    return api.patch(`sellers/${id}/rates`, data);
  }

  function getFullSellerRates ( id: string ): Promise<FullSellerRatesConfigResponse> {
    return api.get(`sellers/${id}/rates`);
  }

  function getFullSellerRatesHistory ( id: string ): Promise<FullSellerRatesHistoryResponse> {
    return api.get(`sellers/rates/${id}`);
  }

  function getSellerRatesHistory ( id: string, filter?: object, pageable?: object ): Promise<SellerRatesHitoryPaginator> {
    return api.get(`sellers/${id}/rates-history/${filterAndPageableToRequest({filter, pageable})}`);
  }
  
  return {
    patchSellerRates,
    getFullSellerRates,
    getFullSellerRatesHistory,
    getSellerRatesHistory
  }
}